export default __webpack_public_path__ + "locales/ar-SA/Payments.json?hash=db98352fdfe91b82013a5bf129b1e230";